// 라이브 스트리밍 실행에 필요한 환경변수입니다.
export const INGEST_ENDPOINT = process.env.REACT_APP_INGEST_ENDPOINT;
export const BROADCAST_URL = process.env.REACT_APP_BROADCAST_URL;
export const ACCESS_KEY_ID = process.env.REACT_APP_ACCESS_KEY_ID;
export const SECRET_KEY_ID = process.env.REACT_APP_SECRET_KEY_ID;
export const CHANNEL_ARN = process.env.REACT_APP_CHANNEL_ARN;
export const CHANNEL_ARN_FULL = process.env.REACT_APP_CHANNEL_ARN_FULL;
export const CHAT_ARN = process.env.REACT_APP_CHAT_ARN;
export const CHANNEL_VALUE = process.env.REACT_APP_CHANNEL_VALUE;
export const S3_PUBLIC = process.env.REACT_APP_PLATFORM_S3_PUBLIC;
export const ICON = process.env.REACT_APP_ICON;

export const API_URL = process.env.REACT_APP_API_URL;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
export const KAKAO_KEY = process.env.REACT_APP_KAKAO_KEY;
export const KAKAO_CLIENT_ID = process.env.REACT_APP_KAKAO_CLIENT_ID;
export const KAKAO_CLIENT_SECRET = process.env.REACT_APP_KAKAO_CLIENT_SECRET;
export const TOSS_CLIENT_KEY = process.env.REACT_APP__TOSS_CLIENT_KEY;
export const TOSS_BRAND_PAY_CLIENT_KEY = process.env.REACT_APP_TOSS_BRAND_PAY_CLIENT_KEY;
export const CRYPTO_SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY;

export const SERVICE = process.env.REACT_APP_SERVICE;
export const PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME;
export const PLATFORM = process.env.REACT_APP_PLATFORM;
export const PLATFORM_INIT = process.env.REACT_APP_PLATFORM_INIT;
export const MODE = process.env.REACT_APP_MODE;
